import React, { useState, useEffect } from 'react';
import "./AboutUs4.css"
const AboutUs = () => {
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const [activeTab, setActiveTab] = useState(0);

  const stats = [
    { number: "15+", label: "Years Experience", color: "#ff6b6b" },
    { number: "5000+", label: "Happy Clients", color: "#4ecdc4" },
    { number: "98%", label: "Success Rate", color: "#45b7d1" },
    { number: "24/7", label: "Support", color: "#96ceb4" }
  ];

  const tabs = [
    {
      title: "Our Story",
      icon: "🏛️",
      content: "Founded in 2009, we've grown from a small advisory team to a trusted financial powerhouse. Our journey has been marked by innovation, client success, and unwavering commitment to financial excellence."
    },
    {
      title: "Our Mission",
      icon: "🎯",
      content: "To democratize financial success by providing world-class advisory services. We believe everyone deserves access to expert financial guidance, regardless of their starting point or investment size."
    },
    {
      title: "Our Values",
      icon: "💎",
      content: "Transparency, integrity, and client-first approach define everything we do. We build long-term relationships based on trust, delivering consistent results through market ups and downs."
    }
  ];

  return (
    <div style={{
      background: '#ffffff',
      padding: '40px 0',
      position: 'relative'
    }}>
   
      <div className="container-fluid px-3">
        {/* Simple Header */}
        <div className="text-center mb-5">
          <h1 style={{
            fontSize: 'clamp(2.2rem, 5vw, 3.5rem)',
            fontWeight: '800',
            color: '#333',
            textAlign: 'center',
            marginBottom: '10px'
          }}>
            About Our Company
          </h1>
          
          <div style={{
            width: '120px',
            height: '4px',
            background: 'linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1)',
            margin: '0 auto',
            borderRadius: '2px'
          }} />
        </div>

        {/* Floating Stats Cards */}
        <div className="row justify-content-center mb-5">
          {stats.map((stat, index) => (
            <div key={index} className="col-6 col-md-3 mb-3">
              <div
                className="stat-card"
                style={{
                  background: `linear-gradient(135deg, ${stat.color}, ${stat.color}dd)`,
                  borderRadius: '20px',
                  padding: '20px',
                  textAlign: 'center',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  border: '3px solid rgba(255,255,255,0.3)',
                  position: 'relative',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  animation: `bounceIn 0.8s ease-out ${index * 0.1}s both`
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(-1)}
              >
                {/* Shine Effect */}
                <div style={{
                  position: 'absolute',
                  top: '-50%',
                  left: hoveredIndex === index ? '100%' : '-50%',
                  width: '50%',
                  height: '200%',
                  background: 'linear-gradient(45deg, transparent, rgba(255,255,255,0.3), transparent)',
                  transform: 'rotate(45deg)',
                  transition: 'left 0.6s ease'
                }} />
                
                <div style={{
                  fontSize: '2.6rem',
                  fontWeight: '900',
                  color: '#fff',
                  marginBottom: '5px',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                }}>
                  {stat.number}
                </div>
                <div style={{
                  fontSize: '1.5rem',
                  color: 'rgba(255,255,255,0.9)',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}>
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Interactive Tab Section with Unique Design */}
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            
            {/* Tab Navigation */}
            <div className="d-flex justify-content-center mb-4 flex-wrap gap-2">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTab(index)}
                  style={{
                    background: activeTab === index ? 
                      'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 
                      'rgba(0,0,0,0.05)',
                    border: 'none',
                    borderRadius: '25px',
                    padding: '12px 24px',
                    color: activeTab === index ? '#fff' : '#333',
                    fontWeight: '600',
                    fontSize: '1.5rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: activeTab === index ? '0 8px 25px rgba(102, 126, 234, 0.4)' : 'none',
                    transform: activeTab === index ? 'translateY(-2px)' : 'translateY(0)'
                  }}
                >
                  <span style={{ marginRight: '8px' }}>{tab.icon}</span>
                  {tab.title}
                </button>
              ))}
            </div>

            {/* Tab Content with Morphing Design */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(248,249,250,0.9))',
              borderRadius: '30px',
              padding: '40px',
              boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
              border: '1px solid rgba(0,0,0,0.05)',
              position: 'relative',
              overflow: 'hidden',
              minHeight: '200px'
            }}>
              
              {/* Decorative Background Pattern */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '150px',
                height: '150px',
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1))',
                borderRadius: '50%',
                transform: activeTab === 0 ? 'scale(1)' : activeTab === 1 ? 'scale(1.2) translate(-20px, 20px)' : 'scale(0.8) translate(-40px, 40px)',
                transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)'
              }} />
              
              <div style={{
                position: 'absolute',
                bottom: '-30px',
                left: '-30px',
                width: '100px',
                height: '100px',
                background: 'linear-gradient(45deg, rgba(255, 107, 107, 0.1), rgba(78, 205, 196, 0.1))',
                borderRadius: '30px',
                transform: `rotate(${activeTab * 45}deg) scale(${1 + activeTab * 0.2})`,
                transition: 'all 0.8s ease'
              }} />

              {/* Tab Content */}
              <div className="tab-content" style={{
                animation: 'slideInFromLeft 0.6s ease-out'
              }}>
                <div className="row align-items-center">
                  <div className="col-12 col-md-3 text-center mb-3 mb-md-0">
                    <div style={{
                      fontSize: '4rem',
                      transform: `rotate(${activeTab * 10}deg) scale(${1 + activeTab * 0.1})`,
                      transition: 'all 0.5s ease',
                      filter: `hue-rotate(${activeTab * 60}deg)`
                    }}>
                      {tabs[activeTab].icon}
                    </div>
                  </div>
                  <div className="col-12 col-md-9">
                    <h3 style={{
                      fontSize: '2.5rem',
                      fontWeight: '700',
                      color: '#2c3e50',
                      marginBottom: '15px'
                    }}>
                      {tabs[activeTab].title}
                    </h3>
                    <p style={{
                      fontSize: '1.5rem',
                      color: '#555',
                      lineHeight: '1.6',
                      margin: 0
                    }}>
                      {tabs[activeTab].content}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;